import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let StoreAnnouncementBannerPreview = class StoreAnnouncementBannerPreview extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    get selectedImage() {
        if (Array.isArray(this.image)) {
            const filteredImages = this.image.filter((img) => img.state === 'idle' || img.state === 'new');
            const filteredImagesLength = filteredImages?.length;
            return (filteredImages[filteredImagesLength - 1]?.url ||
                filteredImages[filteredImagesLength - 1]?.file.dataURL ||
                '');
        }
        return this.image?.file?.photoUrl || '';
    }
    get getDynamicStyles() {
        const paragraphs = this.getParagraphsWithAlignment();
        return {
            paragraphs,
        };
    }
    getParagraphsWithAlignment() {
        if (!this.announcementText) {
            return [];
        }
        const paragraphs = [];
        const regex = /(<(p|h[1-6]|ul|ol)[^>]*>.*?<\/\2>)/g;
        const matches = this.announcementText.match(regex);
        if (matches && matches.length > 0) {
            matches.forEach((paragraph, index) => {
                let style = '';
                // Check for alignment classes
                if (paragraph.includes('ql-align-center')) {
                    style += 'text-align: center;';
                }
                else if (paragraph.includes('ql-align-right')) {
                    style += 'text-align: right;';
                }
                else if (paragraph.includes('ql-align-justify')) {
                    style += 'text-align: justify;';
                }
                // Check for indentation classes
                if (paragraph.includes('ql-indent-1')) {
                    style += 'margin-left: 20px;';
                }
                else if (paragraph.includes('ql-indent-2')) {
                    style += 'margin-left: 40px;';
                }
                else if (paragraph.includes('ql-indent-3')) {
                    style += 'margin-left: 60px;';
                }
                if (paragraph.includes('<h1')) {
                    style += 'font-size: 55px;';
                }
                else if (paragraph.includes('<h2')) {
                    style += 'font-size: 45px;';
                }
                else if (paragraph.includes('<h3')) {
                    style += 'font-size: 40px;';
                }
                else if (paragraph.includes('<h4')) {
                    style += 'font-size: 30px;';
                }
                else if (paragraph.includes('<h5')) {
                    style += 'font-size: 25px;';
                }
                else if (paragraph.includes('<h6')) {
                    style += 'font-size: 20px;';
                }
                if (paragraph.includes('<p')) {
                    style += 'height: 15px; margin-bottom: 5px;';
                }
                else {
                    style += 'margin-bottom: 5px;';
                }
                // Apply styles for unordered lists (ul)
                if (paragraph.includes('<ul')) {
                    style += 'padding-left: 6px; margin: 0; list-style-type: disc;';
                }
                // Apply styles for ordered lists (ol)
                if (paragraph.includes('<ol')) {
                    style += 'list-style-type: decimal; padding-left: 6px; margin: 0px;';
                }
                // Apply specific styles for <li> tags
                if (paragraph.includes('<li')) {
                    style += 'margin-bottom: 0px;';
                }
                // Apply styles for <li> with ql-indent classes
                if (paragraph.includes('ql-indent-1')) {
                    style += 'margin-left: 20px; list-style-type: disc !important;';
                }
                else if (paragraph.includes('ql-indent-2')) {
                    style += 'margin-left: 40px;';
                }
                paragraphs.push({
                    content: paragraph,
                    style,
                });
            });
        }
        return paragraphs;
    }
};
__decorate([
    Prop({ type: String, default: '' })
], StoreAnnouncementBannerPreview.prototype, "announcementText", void 0);
__decorate([
    Prop({ type: String, required: true })
], StoreAnnouncementBannerPreview.prototype, "bgColor", void 0);
__decorate([
    Prop({ type: Array, required: true })
], StoreAnnouncementBannerPreview.prototype, "image", void 0);
__decorate([
    Prop({ type: Number, required: true })
], StoreAnnouncementBannerPreview.prototype, "selectedOption", void 0);
StoreAnnouncementBannerPreview = __decorate([
    Component({
        name: 'StoreAnnouncementBannerPreview',
    })
], StoreAnnouncementBannerPreview);
export default StoreAnnouncementBannerPreview;
